import type { DocReferenceInfo } from '../../entities/peek-view';

type PreviewSearchEditor = {
  host?: {
    std: {
      view: {
        getBlock: (id: string) => unknown;
      };
    };
  } | null;
  origin: HTMLDivElement;
};
type PreviewSearchTarget = Pick<DocReferenceInfo, 'blockIds' | 'elementIds'>;

export function getPreviewSearchHighlightRoots(
  editor: PreviewSearchEditor,
  target: PreviewSearchTarget
): Element[] {
  const ids = [...(target.blockIds ?? []), ...(target.elementIds ?? [])].filter(
    Boolean
  );
  const roots: Element[] = [];
  for (const id of ids) {
    const block = editor.host?.std.view.getBlock(id);
    if (block instanceof Element && !roots.includes(block)) {
      roots.push(block);
    }
  }

  // AffineEditorContainer is an imperative API proxy, not a DOM Node. Its
  // origin property is the real editor root and therefore the only valid
  // fallback for DOM traversal APIs such as Document.createTreeWalker().
  return roots.length > 0 ? roots : [editor.origin];
}
